import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Moderators from '@/features/moderators'

export const Route = createFileRoute('/_authenticated/moderateurs/')({
  component: Moderators,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Modérateurs`,
      },
    ],
  }),
  // beforeLoad: async () => {
  //   try {
  //     const res = await getCurrentUser()
  //     if (!res?.id) {
  //       throw redirect({
  //         to: '/sign-in-2',
  //       })
  //     }
  //   } catch (_) {
  //     throw redirect({
  //       to: '/sign-in-2',
  //     })
  //   }
  // },
})
